<template>
  <NuxtLayout
    name="top"
    :bread-crumb-list="breadcrumb"
  >
    <template #main>
      <div class="main">
        <section class="worldMapTop">
          <div class="worldMapTopTitle">
            <SectionTitle
              title="世界天気"
              righ-text=""
              is-h1
            />
            <ShareButton
              category="TOP"
              :title="title"
            />
          </div>
          <TopWorldMap />
        </section>
      </div>
    </template>
    <template #main-bottom>
      <div class="main">
        <AreaMajorCityWxTable
          :now="now"
          :area-id="'all'"
        />
        <TopAreaCityTable />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <RadarLinkCard
          link="/onebox/tenki/world/radar/"
          :src="`${runtimeConfig.public.gvsUrl}/onebox/img/world/thumb/world/prec.webp`"
          target-area="世界"
        />
      </div>
    </template>
  </NuxtLayout>
</template>

<script setup>
import dayjs from 'dayjs'

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()

const title = '世界天気 - ウェザーニュース'

const breadcrumb = isWebViewFlag
  ? []
  : [
      {
        text: '世界天気',
        to: '/onebox/tenki/world/'
      }
    ]
useCommonHead({
  title,
  description: '【世界天気ならウェザーニュース】世界の約2000地点の2週間先までの天気予報や気温、降水量を掲載。各地の雨雲レーダーは48時間先まで確認できます。世界最大級の観測ネットワークと独自の予測モデル、AI分析によるいちばん当たる予報で、海外旅行や出張など現地の天気に関する全てをサポートします。',
  keywords: '世界天気,2週間,当たる',
  appTitle: '世界天気',
  appCountKey: 'top',
  iconUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_white@2x.png`,
  iconGrayUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_trans@2x.png`,
  iconSettingUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_world_color@2x.png`
})

const now = dayjs().unix()
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}

.worldMapTop {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.worldMapTopTitle {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 5px;
  flex-wrap: wrap;
}

.ads-btf1-sp {
  min-height: 50px;
  margin: 0px auto;
}
</style>
